import { createApp } from 'vue'
import App from './App.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAlignLeft, faBlender, faBolt, faBook, faBrush, faCamera, faCarBattery, faCode, faCodeBranch, faFontAwesome, faGem, faHamsa, faLayerGroup, faPen, faPersonRunning, faRuler, faUserSecret, faV, faVideo, faVrCardboard } from '@fortawesome/free-solid-svg-icons'
import { faAndroid, faApple, faCss3Alt, faGithub, faHtml5, faJsSquare, faMicrosoft, faPython, faReact, faUnity, faVuejs } from '@fortawesome/free-brands-svg-icons'
import { faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faCube } from '@fortawesome/free-solid-svg-icons'
import VueCodeHighlight from 'vue-code-highlight';
import "vue-code-highlight/themes/duotone-sea.css";

// Add icons to the library
library.add(
  faGithub, faLinkedin, faEnvelope, faUserSecret, faVrCardboard, faJsSquare, faAlignLeft, faCodeBranch,
  faVuejs, faCamera, faMicrosoft, faApple, faCode, faLayerGroup, faFontAwesome, faBook, faHtml5, faCss3Alt,
  faBlender, faGem, faBolt, faAndroid, faPython, faReact, faUnity, faPen, faBrush, faVideo, faRuler, faCube,
  faV, faHamsa, faCarBattery, faPersonRunning
)

const app = createApp(App)

// Register the FontAwesomeIcon component globally
app.component('font-awesome-icon', FontAwesomeIcon)

app.use(VueCodeHighlight, {
  theme: 'duotone-sea', // Replace with the theme you want to use
})

// Mount the app to the DOM
app.mount('#app')
